import { render, staticRenderFns } from "./planeZone.vue?vue&type=template&id=652bed6a&scoped=true&"
import script from "./planeZone.vue?vue&type=script&lang=js&"
export * from "./planeZone.vue?vue&type=script&lang=js&"
import style0 from "./planeZone.vue?vue&type=style&index=0&id=652bed6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652bed6a",
  null
  
)

export default component.exports